module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-shg-can be used.8a0ad8a1.webp";